import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('BroadcastService');
    this.rebroadcastAngularJSEvents();
  }

  /**
   * rebroadcast AngularJS events as observables so that Angular components can subscribe to them
   */
  private rebroadcastAngularJSEvents() {
    if (typeof angular !== 'undefined') {
      const element = document.querySelectorAll('div[ui-view]');
      const injector = angular.element(element).injector();

      // rebroadcast AngularJS broadcasts as observables so that Angular subscribers can get the message
      if (injector) {
        const rootScope = injector.get('$rootScope');
        rootScope.$on('document:updated', (event, data) => {
          this.broadcast('document:updated', data);
        });
      }
    }
  }

  broadcast(key: any, data?: any) {
    if (!this.ajsService) {
      console.log('No BroadcastService provided.');
    } else {
      this.ajsService.broadcast(key, data);
    }
  }

  on<T>(key: any): Observable<T> {
    if (!this.ajsService) {
      console.log('No BroadcastService provided.');
    } else {
      return this.ajsService.on(key);
    }
  }
}
